// extracted by mini-css-extract-plugin
module.exports = {"root":"selection-card-body-content_root__sTJ2_"};